import api from '@/utils/api';

/**
 * Update Quote module
 * @param {string} id Company id
 * @param {string} quoteModuleId Quote module id
 * @param {object} quoteModuleData - The Quote module data
 * @returns {Promise}
 */
const updateCompanyQuoteModuleApi = (id, quoteModuleId, quoteModuleData) =>
  api.patch(`/company/${id}/quote-module/${quoteModuleId}`, quoteModuleData);

export default updateCompanyQuoteModuleApi;
